class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
  
      this.cache = new Map();
      this.input = this.querySelector('input[type="search"]');
      this.predictiveSearchResults = this.querySelector('#predictive-search');
      this.filterText = '';

      this.activeQuery = null;
  
      this.input.addEventListener('input', this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this));
    }
  
    onChange() {
      const searchTerm = this.input.value.trim();
  
      if (!searchTerm.length) {
        this.close();
        return;
      }
  
      this.getPredictiveSearchResults(searchTerm);
    }
  
    getPredictiveSearchResults(searchTerm, isHover) {
      this.searchTerm = searchTerm;

      fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            this.close();
            throw error;
          }
  
          return response.text();
        })
        .then((text) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(text, 'text/html');
          const newResults = doc.querySelector('#shopify-section-predictive-search');

          if (!newResults) {
              console.error("Error: #shopify-section-predictive-search not found in response.");
              return;
          }

          const existingResults = this.predictiveSearchResults;

          if (existingResults) {
              Alpine.morph(existingResults, newResults, {
                  updating(el, toEl, childrenOnly) {
                      childrenOnly();
                  },
                  key(el) {
                    if (el.tagName === 'LI') {
                    return el.dataset.queryText;
                  }
              },
              lookahead: true
              });
          }

				  this.filterText = '';
					this.getSearchResults(searchTerm);
					this.open();
          this.createQuery(searchTerm);

        })
        .catch((error) => {
          this.close();
          throw error;
        });
    }

    createQuery(searchTerm) {
      const queryElements = document.querySelectorAll('.predictive-search__query.predictive-search__col > ul li');
  
      let exists = false;
      queryElements.forEach((queryElement) => {
          if (queryElement.dataset.queryText === searchTerm) {
              exists = true;
          }
      });
  
      if (!exists) {
          this.createQueryElement(searchTerm);
      }
  }
  
  createQueryElement(searchTerm) {  
      const queryWrapper = document.querySelector('.predictive-search__query.predictive-search__col > ul');  
      if (!queryWrapper) {
          console.error('queryWrapper not found, make sure the UL exists in the DOM');
          return;
      }
      const newQuery = document.createElement('li');
      newQuery.classList.add('predictive-search__query-item','search-term');
      newQuery.dataset.queryText = searchTerm;
      newQuery.dataset.query = searchTerm;
      newQuery.setAttribute("@mouseover",`searchTerm = '${searchTerm}'`);
      newQuery.setAttribute(":class",`{ 'active': searchTerm === '${searchTerm}' }`);
      newQuery.innerHTML = `<a href="/search?q=${searchTerm}">${searchTerm}</a>`;
      newQuery.textContent === searchTerm ? newQuery.classList.add('active') : newQuery.classList.remove('active');
      queryWrapper.appendChild(newQuery);
  }
  


		getSearchResults(searchTerm) {
      let filterText = this.filterText;
			let searchQuery = '';
	
			if (filterText) {
					searchQuery = `/search?q=${encodeURIComponent(searchTerm)}&${filterText}&section_id=search-dropdown&page=1`;
			} else {
					searchQuery = `/search?q=${encodeURIComponent(searchTerm)}&section_id=search-dropdown&page=1`;
			}

      let cacheKey = `${searchTerm}-${filterText || ''}`;
      if (this.cache.has(cacheKey)) {
        this.updateSearchResults(this.cache.get(cacheKey));
        return; 
      }


      fetch(searchQuery)
        .then((response) => {
          if (!response.ok) {
            let error = new Error(response.status);
            this.close();
            throw error;
          }
  
          return response.text();
        })
        .then((text) => {

         if (filterText) {
          const existingSuggestions = this.querySelector('#search-suggestions');
          const newSuggestions = new DOMParser().parseFromString(text, 'text/html').querySelector('#search-suggestions');
      
          if (existingSuggestions && newSuggestions) {
              Alpine.morph(existingSuggestions, newSuggestions, {
                  key(el) {
                      return el.dataset.productId
                  },
                  lookahead: false 
              });
            }
          } else {
              const existingContainer = this.querySelector('#search-container');
              const newResults = new DOMParser().parseFromString(text, 'text/html').querySelector('#search-dropdown');
          
              if (existingContainer && newResults) {
                  Alpine.morph(existingContainer, newResults, {
                      updating(el, toEl, childrenOnly) {
                          childrenOnly();
                      },
                      key(el) {
                        if (el.tagName === 'LI') {
                        return el.dataset.filter && el.dataset.search || el.dataset.productId;
                      }
                  },
                  lookahead: true
                  });
              }
          } 

          this.cache.set(cacheKey, text);

          (this.requestIdleCallback || setTimeout)(() => {
            this.updateSearchResults(text);
        }, 50);
        
        })
        .catch((error) => {
          this.close();
          throw error;
        });
    }

    updateSearchResults(text) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, 'text/html');
      const newResults = doc.querySelector('#search-dropdown');
  
      if (!newResults) {
          console.error("Error: #search-dropdown not found in response.");
          return;
      }
  
      const applyLimit = () => {
          let limit = 10;
          if (window.innerWidth < 1200) limit = 8;
          if (window.innerWidth < 991) limit = 3;
          if (window.innerWidth < 767) limit = 2;
  
          let results = document.querySelectorAll(".predictive-search__results li");
          results.forEach((result, index) => {
              result.style.display = index < limit ? "block" : "none";
          });
      };
  
      // Apply limit immediately when search results update
      applyLimit();
  
      // Ensure limit is reapplied after `Alpine.morph` updates the DOM
      const onMorphComplete = () => {
          requestAnimationFrame(() => {
              applyLimit();
          });
      };
  
      if (this.filterText !== '') {
          const existingSuggestions = this.querySelector('#search-suggestions');
          const newSuggestions = doc.querySelector('#search-suggestions');
  
          if (existingSuggestions && newSuggestions) {
              Alpine.morph(existingSuggestions, newSuggestions, {
                  key(el) {
                      return el.dataset.productId;
                  },
                  lookahead: false,
                  updated: onMorphComplete // Ensures limit is applied after morphing
              });
          }
      } else {
          const existingContainer = this.querySelector('#search-container');
  
          if (existingContainer) {
              Alpine.morph(existingContainer, newResults, {
                  updating(el, toEl, childrenOnly) {
                      childrenOnly();
                  },
                  key(el) {
                      if (el.tagName === 'LI') {
                          return el.dataset.filter && el.dataset.search || el.dataset.productId;
                      }
                  },
                  lookahead: true,
                  updated: onMorphComplete // Ensures limit is applied after morphing
              });
          }
      }
  
      // Ensure the limit updates dynamically when the window resizes
      window.addEventListener("resize", () => {
          clearTimeout(this.resizeTimeout);
          this.resizeTimeout = setTimeout(applyLimit, 300);
      });
  }
  

    open() {
        this.predictiveSearchResults.style.display = 'block';
				this.attachHoverListener();
    }

    attachHoverListener() {
      if (this._listenersAttached) return;
      this._listenersAttached = true;

      this.searchedQueries = null;
      this.filterText = null;

      const debounceHover = this.debounce((event) => {
          const queryElement = event.target.closest('[data-query]');
          const filterElement = event.target.closest('[data-filter]');

          if (queryElement) {
              this.filterText = '';
              const queryText = queryElement.dataset.query;
              if (this.searchedQueries !== queryText) {
                  this.searchedQueries = queryText;
                  this.getSearchResults(queryText);
              }

              if (this.searchedQueries === queryText) {
                  queryElement.closest('li').classList.add('active');
              } else {
                  queryElement.closest('li').classList.remove('active');
              }
          }

          if (filterElement) {
              const filterText = filterElement.dataset.filter;
              const searchTerm = filterElement.dataset.search;

              if (this.searchedQueries !== searchTerm || this.filterText !== filterText) {
                  this.searchedQueries = searchTerm;
                  this.filterText = filterText;

                  this.getSearchResults(searchTerm);
              }
          }

      }, 200);

      this.predictiveSearchResults.addEventListener('mouseover', debounceHover);
  }
    
    close() {
      this.predictiveSearchResults.style.display = 'none';
    }
  
    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
  }
  
  customElements.define('predictive-search', PredictiveSearch);